import { IsBoolean, ValidateIf, ValidateNested } from "class-validator";
import { Type } from "class-transformer";
import OutputLc from "../../lc";

export default class TransmedAdmin {
  @IsBoolean() public readonly national_coordinator!: boolean;

  @ValidateIf((obj) => obj.lc !== null)
  @Type(() => OutputLc)
  @ValidateNested()
  public readonly lc!: OutputLc | null;

  @IsBoolean() public readonly validate!: boolean;
}
